import api from "./index";

export interface ClinicItem {
  id: string;
  name: string;
}

export const getClinicsByUser = async () => {
  return api.get("/clinic/byUser");
};

export interface ClinicCreatePayload {
  name: string;
  address: string;
  contact: string | null;
  fees: number;
  isOwner: boolean;
  openingTime: string | null; // e.g. 10:10 AM or null
  closeTime: string | null;   // e.g. 10:00 PM or null
  isActive: boolean;
  recurringDays: string[]; // e.g. ["Mon","Wed","Fri"]
}

export interface PaginationWhereClauseItem {
  key: string;
  value: string;
  operator: string;
}

export interface ClinicPaginationPayload {
  curPage: number;
  perPage: number;
  sortBy: string;
  direction: "asc" | "desc";
  whereClause: PaginationWhereClauseItem[];
}

export const createClinic = async (payload: ClinicCreatePayload) => {
  return api.post("/clinic/create", payload);
};

export const getClinicById = async (id: string) => {
  return api.get(`/clinic/getOne/${id}`);
};

export const updateClinic = async (id: string, payload: Partial<ClinicCreatePayload>) => {
  // API mentions update is GET, but using POST aligns with body. If strictly GET, pass via query.
  return api.post(`/clinic/update/${id}`, payload);
};

export const removeClinic = async (id: string) => {
  return api.get(`/clinic/remove/${id}`);
};

export const paginateClinics = async (payload: ClinicPaginationPayload) => {
  return api.post("/clinic/pagination", payload);
};